import { createSlice } from "@reduxjs/toolkit";

const originFormat = {
  access_token: "",
  csrf_token: "",
  id: false,
  code: "",
  name: "",
  email: "",
  phone: "",
  permissions: [],
  transaction_noti: 0,
  points: 0,
  total_deposit_points: 0,
  total_withdraw_points: 0,
  select_theme: "",
  ui_size: "",
  playing_user_ids: [],
  play_game: false,
  user_points: 0,
  user_play_game_id: false,
};

function addSession(data) {
  sessionStorage.setItem("user", JSON.stringify(data));
}

function removeSession() {
  sessionStorage.removeItem("user");
}

function getSession() {
  const user = sessionStorage.getItem("user");
  if (user) {
    return JSON.parse(user);
  }
  return originFormat;
}

const initialState = getSession();

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setState: (state, { payload: user }) => {
      state.access_token = user.access_token;
      state.csrf_token = user.csrf_token;
      state.id = user.id;
      state.code = user.code;
      state.name = user.name;
      state.address = user.address;
      state.email = user.email;
      state.phone = user.phone;
      state.permissions = user.permissions;
      state.points = user.points;
      state.total_deposit_points = user.total_deposit_points;
      state.total_withdraw_points = user.total_withdraw_points;
      state.select_theme = user.select_theme;
      state.ui_size = user.ui_size;

      addSession({
        ...user,
        id: user.id ? user.id : "",
      });
    },

    clearState: (state) => {
      removeSession();
      state.id = false;
    },

    incrementTransactionNoti: (state) => {
      state.transaction_noti += 1;
      const sessionData = getSession();
      if (sessionData) {
        addSession({
          ...sessionData,
          transaction_noti: state.transaction_noti,
        });
      }
    },

    addPlayingUserId: (state, action) => {
      if (!state.playing_user_ids.includes(action.payload)) {
        state.playing_user_ids.push(action.payload);
      }
    },

    removePlayingUserId: (state, action) => {
      state.playing_user_ids = state.playing_user_ids.filter(
        (id) => id !== action.payload
      );
    },

    clearPlayingUserIds: (state) => {
      state.playing_user_ids = [];
    },

    updateUserInfo: (state, { payload }) => {
      const { user_points, play_game, user_play_game_id } = payload;
      state.user_points = user_points;
      state.play_game = play_game;
      state.user_play_game_id = user_play_game_id;

      const sessionData = getSession();
      if (sessionData) {
        addSession({
          ...sessionData,
          user_play_game_id,
          user_points,
          play_game,
        });
      }
    },
    resetTransactionNoti: (state) => {
      state.transaction_noti = 0;
      const sessionData = getSession();
      if (sessionData) {
        addSession({ ...sessionData, transaction_noti: 0 });
      }
    },
  },
});

export const {
  setState,
  clearState,
  incrementTransactionNoti,
  resetTransactionNoti,
  addPlayingUserId, 
  removePlayingUserId,
  clearPlayingUserIds,
  updateUserInfo,
  clearUserId,
} = userSlice.actions;
export default userSlice.reducer;
